import React, { useMemo } from "react";
import { Calendar } from "lucide-react";

import { DashboardCard } from "../DashboardCard";
import { CardHeader } from "../CardHeader";
import { DonutChart, DonutLegend } from "../charts/DonutChart";

import { getLeaveStatusData } from "../../services/dashboardAnalytics";
import { LEAVE_COLORS } from "../../constants/constants";

export const LeaveOverviewCard = React.memo(function LeaveOverviewCard({
  leaves,
}) {
  const leaveData = useMemo(
    () => getLeaveStatusData(leaves),
    [leaves]
  );

  return (
    <DashboardCard>
      <CardHeader
        icon={Calendar}
        iconBg="#FFF7ED"
        iconColor="#EA580C"
        title="Leave Overview"
      />

      <div className="text-xs text-slate-400 font-medium mb-1">
        Leave by Status
      </div>

      <div className="grid grid-cols-2 gap-2 items-center flex-1">
        <DonutChart
          data={leaveData}
          colors={LEAVE_COLORS}
          total={leaves.length}
          centerLabel="Total"
        />

        <DonutLegend
          data={leaveData}
          colors={LEAVE_COLORS}
        />
      </div>
    </DashboardCard>
  );
});